// extracted by mini-css-extract-plugin
module.exports = {"antiIndulged":"antiIndulged_antiIndulged_qv0Vx","mask":"antiIndulged_mask_2e30V"};